import React from 'react';
import { graphql } from "gatsby"

import Pancake from "./Pancake";
import Container from "../Container";
import PancakeIntro from "../PancakeIntro";
import SanityPortableText from '../SanityPortableText';

import "./Video.scss";

const Video = props => {

  const { title, text, videoURL, videoFile, theme, youtubeVideo, blocks } = props;
  const video = videoFile?.asset.url || videoURL;

  return (
    <Pancake className="PancakeVideo" theme={theme}>
      <Container size="Small">
        <PancakeIntro title={title} text={text} />
        <div className="PancakeVideoGrid">
          {blocks?.length > 0 &&
            <div className="PancakeVideoContent">
              <SanityPortableText blocks={blocks} />
            </div>
          }
          {youtubeVideo &&
            <iframe className="PancakeVideoYoutubePlayer" width="560" height="315" src={`https://www.youtube.com/embed/${youtubeVideo.videoID}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          }
          {video &&
            <video controls className="PancakeVideoPlayer">
              <source src={video} type={`video/${videoFile.asset.extension}`} />
            </video>
          }
        </div>
      </Container>
    </Pancake>
  );
}

export const query = graphql`
  fragment SanityPancakeVideo on SanityPancakeVideo {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    theme
    _rawPancakeText
    youtubeVideo {
      videoID
    }
    videoURL
    videoFile {
      asset {
        url
        extension
      }
    }
  }
`

export default Video;